import { useRef, useState } from "react";
import * as S from "./PatientFirm.style"
import { useTranslation } from "react-i18next";
import FlorenzButton from "../../../../../../../florenzComponents/florenzButton";
import SignatureCanvas from 'react-signature-canvas';

function PatientFirm({
  setPatientVerified,
  handleSaveNewPatient
}) {

  const { t, i18n: { language } }= useTranslation("global");
  const sigCanvas = useRef(null);

  const trimCanvas = (c) => {
    var ctx = c.getContext('2d'),
      copy = document.createElement('canvas').getContext('2d'),
      pixels = ctx.getImageData(0, 0, c.width, c.height),
      l = pixels.data.length,
      i,
      bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
      },
      x, y;

    for (i = 0; i < l; i += 4) {
      if (pixels.data[i + 3] !== 0) {
        x = (i / 4) % c.width;
        y = ~~((i / 4) / c.width);

        if (bound.top === null) {
          bound.top = y;
        }

        if (bound.left === null) {
          bound.left = x;
        } else if (x < bound.left) {
          bound.left = x;
        }

        if (bound.right === null) {
          bound.right = x;
        } else if (bound.right < x) {
          bound.right = x;
        }

        if (bound.bottom === null) {
          bound.bottom = y;
        } else if (bound.bottom < y) {
          bound.bottom = y;
        }
      }
    }

    if (bound.top !== null) {
      var trimHeight = bound.bottom - bound.top,
        trimWidth = bound.right - bound.left,
        trimmed = ctx.getImageData(bound.left, bound.top, trimWidth, trimHeight);

      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);

      return copy.canvas;
    }

    return c;
  };

  const handleSubmit = () => {
    if (sigCanvas.current) {
      const canvas = sigCanvas.current.getCanvas();
      const trimmed = trimCanvas(canvas);
      handleSaveNewPatient(trimmed.toDataURL('image/png'));
    }
  };

  function clear () {
    sigCanvas.current.clear()
    setFirmEmpty(true);
  }

  const [firmEmpty, setFirmEmpty] = useState(true);

  const handleCanvasChange = () => {
    if (sigCanvas.current) {
      setFirmEmpty(sigCanvas.current.isEmpty());
    }
  };

  return (
    <S.PatientFirm>
      <div className="header">
        <div className="title">
          {t("chatbotAI.imageReading.imagesAnalysis")}
        </div>
        <div className="subtitle">
          {t("chatbotAI.imageReading.seeDataTreatment")}
        </div>
      </div>
      <div className="firm-container">
        <div className="firm-pad">
          {
            !firmEmpty &&
            <div className="firm-pad__clear-button" onClick={clear}>
              <FlorenzButton
                typeStyle={"secondaryWhite"}
                size="s"
                text={t("globally.clear")}
                onClick={() => {
                  clear();
                }}
              />
            </div>
          }
          <div className="firm-pad__canvas">
            <SignatureCanvas 
              canvasProps={{ className: "firm-pad__canvas-pad" }}
              ref={sigCanvas}
              onEnd={handleCanvasChange}
            />
          </div>
          <div className="firm-pad__label">
            {t("chatbotAI.imageReading.signHereToContinue")}
          </div>
        </div>
        <div className="buttons">
          <div className="cancel-button">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.cancel")}
              onClick={() => {
                setPatientVerified(false);
              }}
            />
          </div>
          <div className="continue-button">
            <FlorenzButton
              typeStyle={"primary"}
              size="s"
              text={t("globally.continue")}
              disabled={firmEmpty}
              icon={firmEmpty && "zaia-i-lock-chat"}
              onClick={() => {
                handleSubmit();
              }}
            />
          </div>
        </div>
      </div>
    </S.PatientFirm>
  );

}

export default PatientFirm;
